import { ReactNode } from "react";
import { createPortal } from "react-dom";
import { useRightSidebarContext } from "./RightSidebarContext";

interface RightSidebarPortalProps {
  children: ReactNode;
}

export const RightSidebarPortal = ({ children }: RightSidebarPortalProps) => {
  const { portalRef } = useRightSidebarContext();

  if (!portalRef.current) {
    return null;
  }

  return createPortal(children, portalRef.current);
};

export default RightSidebarPortal;
